import { Filters } from '../components/Filters';
import { QuotesFilters } from '../components/QuotesFilters';
import ProductList from '../components/product-list';
import GalleryHome from '../components/gallery';
import HeaderFeatures from '../components/header-features';
import Popup from '../components/popups/popup';
import MoreDetailsPopup from '../components/popups/more-details-popup';
import TestProductPopup from '../components/popups/test-product-popup';
import UpdateUserAccount from '../components/update-user-account';
import Cookies from '../components/cookie';
import SmoothScrolling from '../components/smooth-scrolling';
import Common from '../components/common';
import VideoEmbed from '../components/video-embed';
import { BannerController } from '../components/BannerController';
import PageTypes from '../helpers/page-types';
import { Scroller } from '../components/galleries/scroller';
import { getHTMLElement, scrollPageTo, getPositionRelativeToDocument } from '../helpers/dom-interact';
import { LoadingIndicator } from '../components/mixins/loading-indicator';
import { getUrlParams } from '../helpers/handle-url';
import { ButtonPagination } from '../components/pagination/ButtonPagination';
import { InfiniteScrollPagination } from '../components/pagination/InfiniteScrollPagination';
import { NumericPagination } from '../components/pagination/NumericPagination';
import { ApiEndpoints } from '../Configurations/ApiEndpoints';
import { trackProductImpressions } from '../helpers/ProductImpressionsTracker';
import Tracker from '../helpers/tracker';
import { AccordionController } from '../components/AccordionController';
import { ExpandTextController } from '../components/ExpandTextController';
import { WishListComponent } from '../components/WishList';
import { WishListEvents } from '../Modules/Types';
import { MessagePopup } from '../components/messagePopup';
import { TrackingData } from '../helpers/TrackingTypes';
import { GA4SocialNetworkTracker } from '../components/GA4/GA4SocialNetworkTracker';
import { initBanners } from '../components/banners/index';
import { ExpandBannerController } from '../components/ExpandBannerController';

function instantiateScrollers() {
	const scrollers = document.querySelectorAll('.js-products-scroller, .js-styles-scroller, .js-trends-scroller');

	for (let i = 0; i < scrollers.length; i++) {
		const buttonStateIsHidden =
			scrollers[i].classList.contains('js-styles-scroller') ||
			scrollers[i].classList.contains('js-trends-scroller');

		new Scroller(scrollers[i], {
			classes: {
				viewport: '.js-viewport',
				slide: '.js-slide',
				prevButton: '.js-prev-button',
				nextButton: '.js-next-button',
			},
			buttonState: buttonStateIsHidden ? 'is-hidden' : 'is-disabled',
			trackingCategory: TrackingData.PAGE_CP,
		});
	}
}

function checkIfNeedsToJumpToProductGrid(page) {
	const urlParams = getUrlParams('jump');

	if (Object.prototype.hasOwnProperty.call(urlParams, 'jump') && urlParams.jump === 'true') {
		const topOfGrid = getHTMLElement(page, '.filters');

		scrollPageTo(getPositionRelativeToDocument(topOfGrid).top, 0);
	}
}

const Category = function () {
	const hasTestProductOnPage = document.querySelector('[class*="js-test-product"]');
	const page = getHTMLElement(document, '.page');
	const filtersElement = page.querySelector('.filters');
	const categoryList = page.querySelector('.js-categories-list');
	const loadingIndicator = new LoadingIndicator();
	const messagePopup = new MessagePopup(document.querySelector('.js-message-popup'));

	new Common({
		trackingCategory: TrackingData.PAGE_CP,
	}); // Common should be first because it contains error-logger

	initBanners('Category');

	new HeaderFeatures({
		trackingCategory: TrackingData.PAGE_CP,
	});

	new GA4SocialNetworkTracker();

	jQuery('.js-video-teaser').each(function () {
		new VideoEmbed({ el: this });
	});

	const wishListComponents = new WishListComponent({
		trackingCategory: TrackingData.PAGE_CP,
	});

	wishListComponents.addEventListener(WishListEvents.REQUEST_START, () => loadingIndicator.showLoader());
	wishListComponents.addEventListener(WishListEvents.REQUEST_END, () => loadingIndicator.hideLoader());
	wishListComponents.addEventListener(WishListEvents.POPUP_OPEN, (event, settings) =>
		messagePopup.openPopup(settings)
	);
	wishListComponents.addEventListener(WishListEvents.POPUP_CLOSE, () => messagePopup.closePopup());
	wishListComponents.addEventListener(WishListEvents.POPUP_DISABLE, () => messagePopup.disableInnerElements());

	// manage list of product
	const productList = new ProductList({
		holder: '.js-categories-list',
		wishListComponents,
		pageType: PageTypes.CP,
		trackingCategory: TrackingData.PAGE_CP,
	});

	// initialize endless scroll or pagination
	const paginationElement = page.querySelector('.js-infinity-scroll') || page.querySelector('.js-pagination');

	let pagination;

	if (paginationElement) {
		const paginationButtonElement = paginationElement.querySelector('.js-pagination-btn');

		if (paginationButtonElement) {
			pagination = new ButtonPagination(paginationButtonElement, nextPage, categoryName);
		} else if (paginationElement.classList.contains('js-pagination')) {
			pagination = new NumericPagination(paginationElement, nextPage, categoryName);
		} else {
			pagination = new InfiniteScrollPagination(
				paginationElement,
				nextPage,
				categoryName,
				getHTMLElement(paginationElement, '.js-loading-message')
			);
		}

		pagination.addEventListener('ajax:request:call', () => loadingIndicator.showLoader());
		pagination.addEventListener('ajax:request:done', () => loadingIndicator.hideLoader());
		pagination.addEventListener('products:loaded', (e, response) => {
			productList.updateTiles(response);
			instantiateScrollers();
			if (filtersElement && response.pagination) {
				scrollPageTo(getPositionRelativeToDocument(filtersElement).top, 200);
			}
			if (response.odoscopeEvent) {
				Tracker.trackOdoscopeEvent(response.odoscopeEvent);
			}
		});
	}

	if (filtersElement && filtersElement.querySelector('.js-filter-opener')) {
		const filterOptions = {
			category: categoryName,
			trackingCategory: TrackingData.PAGE_CP,
			apiEndpoint:
				paginationElement && paginationElement.classList.contains('js-pagination')
					? ApiEndpoints.SEARCH_PAGINATION_FILTERS
					: ApiEndpoints.SEARCH,
		};

		const filterSection = filtersElement.classList.contains('js-quotes')
			? new QuotesFilters(filtersElement, filterOptions)
			: new Filters(filtersElement, filterOptions);

		filterSection.addEventListener('ajax:request:call', () => loadingIndicator.showLoader());
		filterSection.addEventListener('ajax:request:done', (e, response) => {
			loadingIndicator.hideLoader();
			if (response) {
				productList.updateTiles(response);
				if (pagination) {
					pagination.updatePaginationState(response);
				}
			}
			if (response && response.odoscopeEvent) {
				Tracker.trackOdoscopeEvent(response.odoscopeEvent);
			}
		});
	}

	if (jQuery('#localization-modal').length) {
		const localizationPopup = new Popup({
			popup: '#localization-modal',
			closeBtn: '.modal-window .close-btn, .modal-window .stay-on-page',
		}).init();

		localizationPopup.attachCloseEvent();
	}

	_.each(
		jQuery('.slider-holder'),
		(item) =>
			new GalleryHome({
				holder: item,
				trackingCategory: TrackingData.PAGE_CP,
			})
	);

	const header = document.getElementById('header');

	if (header) {
		new UpdateUserAccount(header, PageTypes.CP);
	}

	new MoreDetailsPopup({ trackingCategory: TrackingData.PAGE_CP });

	if (hasTestProductOnPage) {
		new TestProductPopup({ trackingCategory: TrackingData.PAGE_CP });
	}

	new Cookies();

	new SmoothScrolling();

	new BannerController(TrackingData.PAGE_CP);

	instantiateScrollers();

	checkIfNeedsToJumpToProductGrid(page);

	if (categoryList) {
		trackProductImpressions(categoryList);
	}

	_.each(jQuery(AccordionController.accordionQuerySelector), (item) => new AccordionController(item));

	_.each(jQuery(ExpandTextController.buttonRowQuerySelector), (item) => new ExpandTextController(item));

	_.each(jQuery(ExpandBannerController.buttonRowQuerySelector), (item) => new ExpandBannerController(item));
};

new Category();
